import { render, staticRenderFns } from "./chat_v2_mobile.vue?vue&type=template&id=752edc3a&scoped=true&"
import script from "./chat_v2_mobile.vue?vue&type=script&lang=js&"
export * from "./chat_v2_mobile.vue?vue&type=script&lang=js&"
import style0 from "./chat_v2_mobile.vue?vue&type=style&index=0&id=752edc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752edc3a",
  null
  
)

export default component.exports